import { formatISO } from 'date-fns';
import { useCallback } from 'react';

import { DEFAULT_TOPIC } from 'applications/GSP/pages/ParentHelper/constants';
import {
  getDefaultTopicIndex,
  sortChatsByDateAndFavorite,
} from 'applications/GSP/pages/ParentHelper/utils';

import type {
  ChatId,
  SetChatTopics,
  Topic,
} from 'applications/GSP/pages/ParentHelper/types';

export const useSetChatHistory = (
  chatTopics: Topic[],
  chatId: ChatId,
  setChatTopics: SetChatTopics,
) => {
  const defaultTopicIndex = getDefaultTopicIndex(chatTopics);

  return useCallback(
    (chatIdFromResponse: ChatId, question: Topic['topic']) =>
      setChatTopics(prevData =>
        prevData
          .map((topic, index) => {
            if (chatId && topic.chatId === chatId) {
              return {
                ...topic,
                lastUpdatedDate: formatISO(new Date()),
              };
            }

            if (defaultTopicIndex === index) {
              return {
                ...DEFAULT_TOPIC,
                topic: question,
                chatId: chatIdFromResponse,
              };
            }

            return topic;
          })
          .sort(sortChatsByDateAndFavorite),
      ),
    [chatId, defaultTopicIndex, setChatTopics],
  );
};
